import React, { useState, useContext, useEffect, useRef } from "react";
import * as Icon from "react-bootstrap-icons";

import { CartContext } from "../context/CartContext";
import { ProductContext } from "../context/ProductContext";
import Navbar from "../components/Navbar";
import { useParams } from "react-router-dom";
import axios from "axios";

const Product = () => {
  const [galleryImage, setGalleryImage] = useState("");
  const { addToCart } = useContext(CartContext);
  let { id } = useParams();
  const [product, setProduct] = useState(null);

  const [loading, setLoading] = useState(false); // State to manage loading

  // Function to fetch product details
  const fetchProductDetails = async (id) => {
    setLoading(true); // Set loading to true before the API call

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}product/productDetails/${id}`
      );
      setProduct(response?.data?.product); // Store the product details in state
      setGalleryImage(response?.data?.product?.image[0]);
    } finally {
      setLoading(false); // Set loading to false after the API call completes
    }
  };

  useEffect(() => {
    if (id) {
      fetchProductDetails(id);
    }
  }, [id]);

  return (
    <>
      {loading ? (
        <>
          <div className="d-flex justify-content-center align-items-center loading-section">
            <div className="spinner-border" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        </>
      ) : (
        <div className="container mt-5 p-3">
          <div className="row p-4">
            <div className="col-lg-6 mb-lg-0 mb-md-3 mb-3 img-sec">
              <div className="row">
                <div className="col-2">
                  <div className="row">
                    {product?.image.map((image, i) => (
                      <div key={i} className="col-12 mb-3">
                        <div
                          className={`w-100 border border-1 ${galleryImage === image ? "border-success" : ""
                            } gallery-side`}
                          onClick={() => setGalleryImage(image)}
                        >
                          <img
                            src={`${process.env.REACT_APP_API_URL +
                              process.env.REACT_APP_product_IMAGE_URL +
                              image
                              }`}
                            className="w-100"
                            alt={image}
                            onError={(e) =>
                              (e.target.src = `${process.env.PUBLIC_URL}/assets/dummy.png`)
                            }
                          />
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="col-10 p-0">
                  <img
                    src={`${process.env.REACT_APP_API_URL +
                      process.env.REACT_APP_product_IMAGE_URL +
                      galleryImage
                      }`}
                    className="border border-3 w-100 p-3 rounded"
                    alt={galleryImage}
                    onError={(e) =>
                      (e.target.src = `${process.env.PUBLIC_URL}/assets/dummy.png`)
                    }
                  />

                  <div className="mt-4">
                    {product?.stockQty > 0 ? (
                      <button
                        onClick={() => addToCart(product.id, product?.minimumOrderQty)}
                        className="btn btn-success w-100 p-2"
                      >
                        <Icon.Cart3 className="me-3" size={20} />
                        Add to Cart
                      </button>
                    ) : (
                      <h4 className="text-muted text-center">Out of stock</h4>
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-6 p-sm-2 p-md-5 p-sm-2 rounded">
              <h1 className="fw-bold">{product?.title}</h1>

              <div className="d-flex align-items-center mb-2">
                <p
                  className="card-text text-muted mt-3"
                  style={{
                    marginRight: "auto",
                    fontSize: "14px",
                  }}
                >
                  SKU - {product?.sku}
                </p>

                <p
                  className="card-text me-2"
                  style={{
                    textDecoration: "line-through",
                    color: "#888",
                    marginBottom: 0,
                    fontSize: "16px",
                  }}
                >
                  ₹{product?.price}
                </p>

                <p
                  className="card-text me-2"
                  style={{
                    color: "green",
                    fontWeight: "bold",
                    marginBottom: 0,
                    fontSize: "16px",
                  }}
                >
                  {product?.discount_percentage}% off
                </p>

                <p
                  className="card-text"
                  style={{
                    fontWeight: "bold",
                    color: "black",
                    marginBottom: 0,
                    fontSize: "16px",
                  }}
                >
                  ₹{product?.update_price}
                </p>
              </div>

              <div>
                {/* Description */}
                <div
                  dangerouslySetInnerHTML={{ __html: product?.description }}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Product;
